/**
 * Condicoes do contrato INFORMADAS pelo banco (30/09/2026).
 *
 * O banco tem a propria regra de calculo — parcela, financiado, liquido, IOF e
 * CET saem do sistema dele, e o numero do contrato tambem. A averbadora nao
 * refaz a conta: guarda o que o banco informou e confere so' os LIMITES. E' o
 * que o mercado faz (SIAPE `incluirContratoV2`, Consig-Sen, eConsig): o banco
 * informa os numeros; a averbadora trava margem, prazo e teto de taxa do orgao.
 *
 * Reverte a decisao 4 da spec 014 ("parcela calculada pelo CET"). A coerencia
 * entre parcela e CET virou AVISO, nao trava — decisao do Caio, 30/09/2026.
 */
import { parcelaPeloCet } from "./teto-cet.js";
/**
 * Quanto a parcela informada pode se afastar do PMT(liquido, n, CET) antes de
 * a tela avisar. O banco calcula com convencoes proprias (dias corridos, data
 * de liberacao, arredondamento), entao diferenca pequena e' normal; 2% pega
 * erro de digitacao (CET trocado, parcela de outro prazo) sem gritar a toa.
 */
export const TOLERANCIA_COERENCIA_PARCELA = 0.02;
/**
 * A parcela informada condiz com o CET informado? `null` quando condiz, ou
 * quando falta dado para conferir. So' produto sujeito ao teto de CET chama —
 * no cartao a taxa e' juros do rotativo e a conta e' outra.
 */
export function avisoCoerenciaParcela(c) {
    if (!(c.parcela > 0) || !(c.valorLiquido > 0) || !(c.parcelas > 0) || !(c.cetAm > 0))
        return null;
    const esperada = parcelaPeloCet({
        valorLiquido: c.valorLiquido,
        parcelas: c.parcelas,
        cetAm: c.cetAm,
        diasCarencia: c.diasCarencia,
    });
    if (!(esperada > 0))
        return null;
    const diferenca = Math.abs(c.parcela - esperada) / esperada;
    if (diferenca <= TOLERANCIA_COERENCIA_PARCELA)
        return null;
    return { parcelaPeloCet: Math.round(esperada * 100) / 100, diferenca };
}
/**
 * Faixa de prazo que vale para o banco no convenio:
 *
 * - minimo = o menor inicio de faixa entre as tabelas ativas do banco;
 * - maximo = o menor entre o teto do convenio (prefeitura) e o maior fim de
 *   faixa das tabelas.
 *
 * Sem tabela ativa, vale 1× ate o teto do convenio: averbar sem tabela e'
 * permitido desde 30/09/2026 (a tabela deixou de ser trava de CET). Faixa com
 * `min > max` (tabelas todas acima do teto) nao cabe prazo nenhum — quem chama
 * recusa com a faixa na mensagem.
 */
export function faixaDePrazoDoBanco(tetoConvenio, tabelas) {
    if (tabelas.length === 0)
        return { min: 1, max: tetoConvenio };
    const inicios = tabelas.map((t) => {
        const m = Number(t.prazoMinMeses ?? 0);
        return Number.isFinite(m) && m > 0 ? m : 1;
    });
    const fins = tabelas.map((t) => Number(t.prazoMaxMeses));
    return { min: Math.min(...inicios), max: Math.min(tetoConvenio, Math.max(...fins)) };
}
/** Motivo da recusa quando o prazo cai fora da faixa; `null` quando cabe. */
export function prazoForaDaFaixa(parcelas, faixa, convenioNome) {
    if (parcelas >= faixa.min && parcelas <= faixa.max)
        return null;
    const onde = convenioNome ? ` no convenio ${convenioNome}` : "";
    if (faixa.min > faixa.max) {
        return `Nenhum prazo disponivel${onde}: as tabelas do banco comecam em ${faixa.min}x e o teto e ${faixa.max}x.`;
    }
    return `Prazo de ${parcelas}x fora do permitido${onde}: de ${faixa.min}x a ${faixa.max}x (tabelas do banco e teto do convenio).`;
}
//# sourceMappingURL=condicoes-informadas.js.map